// 单页静态展示用数据（示意人物均采用化名 / 占位，仅用于版式陈列）
export const navLinks = [
  { id: "featured", label: "新进料" },
  { id: "topics", label: "话题墙" },
  { id: "dossier", label: "人物档案" },
  { id: "comments", label: "热评走廊" },
  { id: "note", label: "编辑手记" },
];

export const featuredStats = [
  { label: "已归档人物", value: "26" },
  { label: "持续补料批次", value: "12" },
  { label: "收藏可当目录", value: "同篇更新" },
];

export interface Persona {
  id: string;
  initials: string;
  handle: string;
  zone: string;
  tag: string;
  title: string;
  desc: string;
  heat: string;
  comments: string;
  status: "续料中" | "已归档";
  hot?: boolean;
}

export const featuredPersonas: Persona[] = [
  {
    id: "p1",
    initials: "燃",
    handle: "@大狼说真话 · 情感区",
    zone: "情感口播",
    tag: "人设翻车",
    title: "“温柔导师”人设下的旧账，塌到评论区起义",
    desc: "从「替姐妹出头」到被扒出一整套文案代运营流水线，黑历史越追越多。",
    heat: "12.6w",
    comments: "4312",
    status: "续料中",
    hot: true,
  },
  {
    id: "p2",
    initials: "桃",
    handle: "@桃气圆掌柜 · 带货区",
    zone: "直播带货",
    tag: "选品翻车",
    title: "带货一姐直播间老底：样品与到手根本不是同一批",
    desc: "吹上天的「源头直发」翻车旧账逐条对不上，评论区晒单成了大型对照现场。",
    heat: "9.8w",
    comments: "2876",
    status: "已归档",
  },
  {
    id: "p3",
    initials: "北",
    handle: "@北野学长 · 知识付费区",
    zone: "知识付费",
    tag: "学历质疑",
    title: "「名校学霸」讲师，被旧同学把履历一页页翻了出来",
    desc: "卖课话术里那串头衔，和毕业照时间线对不上号，学员排队来吃瓜。",
    heat: "7.4w",
    comments: "1984",
    status: "续料中",
  },
  {
    id: "p4",
    initials: "鹿",
    handle: "@鹿行千里 · 剧情号",
    zone: "剧情短剧",
    tag: "违约跑路",
    title: "红了就拆伙，剧情号背后的分成旧账掰扯不清",
    desc: "从前台CP到背后分账，昔日搭档把合同复印件甩上了网。",
    heat: "5.1w",
    comments: "1207",
    status: "已归档",
  },
];

export interface TopicGroup {
  group: string;
  desc: string;
  topics: { name: string; count: string; hot?: boolean }[];
}

export const topicWall: TopicGroup[] = [
  {
    group: "塌房现场",
    desc: "当场被锤的方向，按题材分开追更",
    topics: [
      { name: "人设崩塌", count: "34", hot: true },
      { name: "带货翻车", count: "29", hot: true },
      { name: "学历质疑", count: "18" },
      { name: "数据造假", count: "15" },
    ],
  },
  {
    group: "旧账重提",
    desc: "几年前的言论与合同，被翻出来二次发酵",
    topics: [
      { name: "早期言论", count: "22" },
      { name: "违约跑路", count: "17" },
      { name: "分成纠纷", count: "12", hot: true },
      { name: "消失的店", count: "9" },
    ],
  },
  {
    group: "感情纠葛",
    desc: "从前台到幕后，评论区最常追问的那类瓜",
    topics: [
      { name: "恋爱旧账", count: "14", hot: true },
      { name: "CP 拆伙", count: "11" },
      { name: "团队内讧", count: "8" },
    ],
  },
];

export interface DossierRow {
  no: string;
  name: string;
  zone: string;
  mainline: string;
  updated: string;
  status: "续料中" | "已归档";
  heat: string;
  tag: string;
}

export const dossierRows: DossierRow[] = [
  { no: "001", name: "大狼说真话", zone: "情感口播", mainline: "文案代运营 · 人设流水线", updated: "今晨", status: "续料中", heat: "12.6w", tag: "人设崩塌" },
  { no: "002", name: "桃气圆掌柜", zone: "直播带货", mainline: "样品货不对板 · 源头话术", updated: "昨 18:20", status: "已归档", heat: "9.8w", tag: "带货翻车" },
  { no: "003", name: "北野学长", zone: "知识付费", mainline: "履历头衔 · 学历旧账", updated: "昨 09:12", status: "续料中", heat: "7.4w", tag: "学历质疑" },
  { no: "004", name: "鹿行千里", zone: "剧情短剧", mainline: "分成拆伙 · 合同复印件", updated: "09-07", status: "已归档", heat: "5.1w", tag: "违约跑路" },
  { no: "005", name: "阿茶茶茶", zone: "颜值测评", mainline: "早期争议言论 · 二次发酵", updated: "09-06", status: "续料中", heat: "4.3w", tag: "早期言论" },
  { no: "006", name: "栗子熟了", zone: "生活探店", mainline: "数据注水 · 刷量实锤", updated: "09-04", status: "已归档", heat: "3.9w", tag: "数据造假" },
];

export interface CommentItem {
  initials: string;
  name: string;
  role: string;
  text: string;
  likes: string;
  replies: string;
  source: string;
}

export const commentWall: CommentItem[] = [
  {
    initials: "瓜",
    name: "吃瓜群众甲",
    role: "追更型",
    text: "就爱这种按人物分批整理的，追一个是一个，不像别的号刷一堆没下文。",
    likes: "2.1w",
    replies: "386",
    source: "@大狼说真话 档案页",
  },
  {
    initials: "等",
    name: "蹲后续的V",
    role: "收藏型",
    text: "收藏当目录用这话是真的，新料都补进同一篇，找起来不费劲。",
    likes: "1.4w",
    replies: "210",
    source: "@北野学长 档案页",
  },
  {
    initials: "锤",
    name: "旧瓜考古员",
    role: "挖坟型",
    text: "头部主播的老底真耐扒，越早的号越有得看，评论区全是当年截图。",
    likes: "9800",
    replies: "154",
    source: "@桃气圆掌柜 档案页",
  },
  {
    initials: "线",
    name: "瓜田接线员",
    role: "站队围观",
    text: "翻车合集能不能加个「已澄清」分区？有些看着看着就反转了，想区分下。",
    likes: "5300",
    replies: "91",
    source: "热评走廊",
  },
];

export const updateNotes = [
  { date: "09-09", tag: "补料", text: "@大狼说真话 更新两条早期口播录音对照，归入同一档案。", hot: true },
  { date: "09-08", tag: "归档", text: "@桃气圆掌柜 选品翻车旧账整理完毕，标记为已归档批次。", hot: false },
  { date: "09-07", tag: "新开", text: "@鹿行千里 分成纠纷开辟新档案，合同截图按时间线排好。", hot: false },
  { date: "09-06", tag: "补料", text: "@阿茶茶茶 早期言论二次发酵，留言补充持续并入原篇。", hot: false },
];